import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@app/services/auth/auth.service';
import { ToasterService } from '@app/services/toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class HasPermissionsGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toasterService: ToasterService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.checkPermission( route.data );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.checkPermission( childRoute.data );
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission( route.data );
  }

	async checkPermission(routeData: any) {
    await this.authService.isSigned();

		let access = true;
		if (routeData?.permission != null) {
			access = this.authService.hasPermission( routeData.permission, routeData.inclusivePermission );
		}
		if (!access) {
			this.toasterService.showError( `Unauthorized, you were redirected to the home view.` );
			this.router.navigateByUrl('/project/calendar');
		}
		return access;
	}

}
